import React from 'react';
import AccessPolicyNextGenBaseEditorModal from './AccessPolicyNextGenBaseEditorModal';
import {ACCESS_POLICY_INCOMING} from '../../EditorPages/AbstractObjects/GatewayPlan/InnerPages/BaseAccessPolicy/util';


function AccessPolicyNextGenIncomingEditorModal({
                                                    baseObjectName,
                                                    isOpen = false,
                                                    width = 710,
                                                    height = 610,
                                                    onCancel,
                                                    onSuccess,
                                                    defaultObject,
                                                    objectType,
                                                    uoTableData,
                                                    zonesData,
                                                    setUoTableDataValue,
                                                    setAppiDataValue
                                                }) {

    return (
        <>
            <AccessPolicyNextGenBaseEditorModal
                baseObjectName={baseObjectName}
                isOpen={isOpen}
                width={width}
                height={height}
                onCancel={onCancel}
                onSuccess={onSuccess}
                defaultObject={defaultObject}
                objectType={objectType}
                uoTableData={uoTableData}
                zonesData={zonesData}
                incomingOrOutgoing={ACCESS_POLICY_INCOMING}
                setAppiDataValue={setAppiDataValue}
                setUoTableDataValue={setUoTableDataValue}
            />
        </>
    );

}

export default AccessPolicyNextGenIncomingEditorModal;